import React from "react";
import { formatDetailValue, getNestedValue } from "../utils/valueUtils";

function getFieldClassName(column, extraClass = "") {
  const classes = ["safety-row-details__field"];

  if (column?.full) classes.push("safety-row-details__field--full");
  if (extraClass) classes.push(extraClass);

  return classes.join(" ");
}

export function FieldShell({
  label,
  column,
  children,
  details,
  className = "",
}) {
  return (
    <div className={getFieldClassName(column, className)}>
      <div className="safety-row-details__label">{label}</div>
      <div className="safety-row-details__value">{children}</div>
      {details}
    </div>
  );
}

export function EmptyField({ label, column }) {
  return (
    <FieldShell label={label} column={column}>
      <span className="safety-row-details__dash">—</span>
    </FieldShell>
  );
}

export function DetailsBox({ source, fields = [] }) {
  if (!source || !fields.length) return null;

  return (
    <div className="safety-row-details__details-card">
      <ul className="safety-row-details__details-list">
        {fields.map((fieldKey) => {
          const value = getNestedValue(source, fieldKey);

          return (
            <li key={fieldKey} className="safety-row-details__details-item">
              <div className="safety-row-details__details-key">{fieldKey}</div>
              <div className="safety-row-details__details-value">
                {formatDetailValue(value)}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
